
import {
    Card,
    CardContent,
} from "./ui/card";
import { Button } from "./ui/button";
import { Activity, BarChart3, Users } from "lucide-react";
import { Link } from "@inertiajs/react";

export function AboutCard() {
    return (
        <Card className="mb-8 overflow-hidden shadow-sm">
            <CardContent className="p-0">
                <div className="flex flex-col">
                    {/* Top Section: Hero/CTA */}
                    <div className="p-8 flex flex-col justify-center bg-gray-50/50 border-b border-gray-100">
                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-4">
                            Welcome to Timing Tower
                        </h2>
                        <p className="text-gray-600 text-base mb-6 leading-relaxed">
                            The ultimate companion for sim racers. Track your progress, analyse
                            your performance, and connect with other drivers to elevate your racing game.
                        </p>
                        <div className="">
                            <Link href="/register">
                                <Button size="lg" className="w-full font-semibold">
                                    Get Started
                                </Button>
                            </Link>
                        </div>
                    </div>

                    {/* Bottom Section: Features */}
                    <div className="p-8 bg-white">
                        <div className="space-y-8">
                            <div className="flex gap-4">
                                <div className="flex-shrink-0">
                                    <div className="w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center text-orange-600">
                                        <Activity className="h-5 w-5" />
                                    </div>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-1">Automatic Imports</h3>
                                    <p className="text-sm text-gray-500 leading-relaxed">
                                        Seamlessly sync your iRacing sessions and results automatically without manual uploads.
                                    </p>
                                </div>
                            </div>

                            <div className="flex gap-4">
                                <div className="flex-shrink-0">
                                    <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
                                        <BarChart3 className="h-5 w-5" />
                                    </div>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-1">Performance Analysis</h3>
                                    <p className="text-sm text-gray-500 leading-relaxed">
                                        Deep dive into your lap times and consistency. Visualise your progress over time.
                                    </p>
                                </div>
                            </div>

                            <div className="flex gap-4">
                                <div className="flex-shrink-0">
                                    <div className="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
                                        <Users className="h-5 w-5" />
                                    </div>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-1">Social Feed</h3>
                                    <p className="text-sm text-gray-500 leading-relaxed">
                                        Follow friends. See their latest sessions, records, and achievements.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
